"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = exports.ButtonWrapper = exports.ImageContainer = exports.Heading = exports.GenericErrorContainer = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const atoms_1 = require("../../../atoms");
exports.GenericErrorContainer = native_1.default.View `
  height: ${({ height }) => (height ? `${height}` : '100%')};
  padding: 0 ${({ theme }) => `${theme.bpCore.gridSize * 2}px`};
`;
exports.Heading = native_1.default(atoms_1.Heading5) `
  font-family: Roboto-Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.7px;
  text-align: center;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.bpCore.errorFallback.genericError.headingColor};
`;
exports.ImageContainer = native_1.default.View `
  margin-bottom: 16px;
`;
exports.ButtonWrapper = native_1.default.View `
  margin-top: 32px;
  width: 100%;
`;
exports.Message = native_1.default(atoms_1.PText) `
  text-align: center;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.7px;
  color: ${({ theme }) => theme.bpCore.errorFallback.genericError.messageColor};
`;
